exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".makereservationform .control-label{text-align: left}\n.uploadImgBox{overflow: hidden}\n.uploadImgBox span{float: left; margin-right: 5px}\n.uploadImgBox input[type=\"file\"]{position: absolute; left: 0; top: 0; height: 100%; width: 100%; opacity: 0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/contactdetail/contactdetail.component.css
// module id = ../../../../../src/app/contactdetail/contactdetail.component.css
// module chunks = main